<template>
  <div class="l:flex l:gap-8 bg-background-blue px-4 py-8 l:p-12 mb-8 justify-center m:justify-end">
    <div class="text-center justify-center l:text-left l:justify-start">
      <b-headline typography="h2" type="h2" class="text-blue" v-html="$t(`${userSegment}.headline`)" />
      <p class="mb-8" v-html="$t(`${userSegment}.description`)" />
      <button-link variant="product-interaction" href="/business/book-a-demo" class="max-w-xs block mx-auto l:mx-0">
        {{ $t(`${userSegment}.button`) }}
      </button-link>
    </div>
    <high-five-image class="flex-shrink-0 block m-auto mt-8" />
  </div>
</template>

<script>
import ButtonLink from "@/component-library/button-link"
import BHeadline from "@/component-library/b-headline"
import HighFiveImage from "./high-five-image"

export default {
  name: "B2bPromotionBanner",
  components: {
    HighFiveImage,
    ButtonLink,
    BHeadline
  },
  props: {
    userSegment: {
      type: String,
      default: "basic"
    }
  },
  i18n: {
    messages: {
      en: {
        basic: {
          headline: "You're all finished!<br>Hungry for more?",
          description:
            "Get in touch to learn how connecting people to powerful ideas can help your organization thrive.",
          button: "Get in touch"
        },
        premium: {
          headline: "Want to share Blinkist with your team?",
          description:
            "<strong>Did you know we also offer company subscriptions?</strong> Click below, or ask your Learning & Development team to get in touch, to find out how you and your team can use Blinkist to level up—personally and professionally.",
          button: "Learn more"
        }
      },
      de: {
        basic: {
          headline: "Geschafft!<br>Wollen Sie mehr Wissen?",
          description:
            "Wir zeigen Ihnen, wie Ihr Unternehmen von den besten Erkenntnissen aus unseren Blinks profitieren kann.",
          button: "Kontaktieren Sie uns"
        },
        premium: {
          headline: "Blinkist gibt es auch für Unternehmen!",
          description:
            "<strong>Mit Blinkist kannst du dich persönlich und beruflich weiterentwickeln – alleine oder mit deinem Team.</strong> Erfahre, wie dein Unternehmen von Blinkist profitiert und schlage deiner Personalabteilung vor, Blinkist Business als Benefit anzubieten. Gemeinsam erreicht ihr mehr!",
          button: "Mehr erfahren"
        }
      }
    }
  }
}
</script>
